import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ categories }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 border border-border shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Target" size={24} className="text-primary" />
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
          Suivi de Progression
        </h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
        {categories?.map((category, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className="relative w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 mb-3">
              <svg className="transform -rotate-90 w-full h-full">
                <circle
                  cx="50%"
                  cy="50%"
                  r="45%"
                  stroke="var(--color-muted)"
                  strokeWidth="6"
                  fill="none"
                />
                <circle
                  cx="50%"
                  cy="50%"
                  r="45%"
                  stroke={category?.color}
                  strokeWidth="6"
                  fill="none"
                  strokeDasharray={`${2 * Math.PI * 45} ${2 * Math.PI * 45}`}
                  strokeDashoffset={2 * Math.PI * 45 * (1 - category?.score / 100)}
                  strokeLinecap="round"
                  className="transition-all duration-1000 ease-out"
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">
                  {category?.score}%
                </span>
              </div>
            </div>
            <h3 className="text-xs md:text-sm lg:text-base font-medium text-center text-foreground mb-1">
              {category?.name}
            </h3>
            <p className="text-xs text-muted-foreground text-center line-clamp-2">
              {category?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressTracker;